export const libroPedidoObject = {
    id_libro:         null,
    id_curso_escolar: null,
    fecha:            null,
    cantidad_pedida:  null,
    cantidad_llegada: null,
}